(function() {
    'use strict';
    
    // ---------------------------------------------------------------
    //
    // パフューム 2行カルーセル & モーダル機能
    //
    // ---------------------------------------------------------------

    /**
     * パフューム機能クラス
     * 重複宣言を防ぐためのチェック
     */
    if (typeof window.PerfumeManager === 'undefined') {
    class PerfumeManager {
        constructor() {
            this.products = [];
            this.currentModalIndex = 0;
            this.swiper = null;
            this.modalIsOpen = false;
            
            this.init();
        }

        /**
         * 画像URLを正規化
         * - http/https/data/file スキームはそのまま
         * - ルート相対パス(/...)はそのまま
         * - Windowsの絶対パス(C:\path\to\img.jpg)は file:///C:/path/to/img.jpg に変換
         * - 相対パスは現在のURLを基準に解決
         * @param {string} inputUrl
         * @returns {string}
         */
        resolveImageUrl(inputUrl) {
            if (!inputUrl || typeof inputUrl !== 'string') return '';

            const trimmed = inputUrl.trim();

            // 既に完全なURLやdata/fileスキーム
            if (/^(https?:\/\/|data:|file:\/\/)/i.test(trimmed)) {
                return trimmed;
            }

            // ルート相対
            if (trimmed.startsWith('/')) {
                return trimmed;
            }

            // Windows絶対パス (例: C:\images\a.jpg または D:/images/a.jpg)
            if (/^[a-zA-Z]:[\\\/]/.test(trimmed)) {
                const replaced = trimmed.replace(/\\/g, '/');
                return `file:///${replaced}`;
            }

            // それ以外は相対パスとみなし、現在のURLを基準に解決
            try {
                return new URL(trimmed, window.location.href).href;
            } catch (e) {
                return trimmed;
            }
        }

        /**
         * 初期化処理
         */
        init() {
            this.loadProducts();
            this.initCarousel2Row();
            this.initModal();
            this.handleResize();
            this.preloadModalImages();
        }

        /**
         * HTMLから商品データを読み込み
         */
        loadProducts() {
            const cards = document.querySelectorAll('.card[data-product-index]');
            this.products = Array.from(cards).map((card, index) => ({
                index: parseInt(card.dataset.productIndex) || index,
                title: card.dataset.title || '',
                subtitle: card.dataset.subtitle || '',
                titleDesc: card.dataset.titlDesc || '',
                description: card.dataset.description || '',
                modalImage: card.dataset.modalImage || card.querySelector('.card__image')?.src || '',
                ctaHref: card.dataset.ctaHref || '',
                gaLabel: card.getAttribute('data-cta-ga') || '',
                top: card.dataset.top || '',
                middle: card.dataset.middle || '',
                last: card.dataset.last || '',
                hasNewBadge: card.dataset.hasNewBadge === 'true',
                badgeText: card.querySelector('.card__badge')?.textContent || '',
                image: card.querySelector('.card__image')?.src || '',
                alt: card.querySelector('.card__image')?.alt || '',
                element: card
            }));
        }

        /**
         * 2行カルーセルレイアウト初期化
         */
        initCarousel2Row() {
            // Swiperライブラリの存在チェック
            if (typeof Swiper === 'undefined') {
                console.warn('Swiper library is not loaded');
                return;
            }
            
            // Swiperコンテナの存在チェック
            const swiperContainer = document.querySelector('.perfume_carousel');
            if (!swiperContainer) return;
            
            // 既存のSwiperを破棄
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
            
            // Swiperを初期化
            try {
                this.swiper = new Swiper(".perfume_carousel", {
                    grid: {
                        rows: 2,
                        fill: "row",
                    },
                    slidesPerView: 2.2,
                    spaceBetween: 15,
                    allowTouchMove: true,
                    navigation: false,
                    pagination: false,
                    loop: false,
                    centeredSlides: false,
                    breakpoints: {
                        769: {
                            slidesPerView: 5.5,
                        }
                    }
                });
            } catch (error) {
                console.error('Failed to initialize Swiper:', error);
            }
        }



        /**
         * Swiperを破棄
         */
        destroySwiper() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }

        /**
         * モーダル機能初期化
         */
        initModal() {
            this.setupModal();
            this.setupEventListeners();
        }

        /**
         * イベントリスナー設定
         */
        setupEventListeners() {
            // カードクリックイベント
            document.addEventListener('click', (e) => {
                const card = e.target.closest('.card');
                if (card && card.dataset.productIndex !== undefined) {
                    const cardIndex = parseInt(card.dataset.productIndex);
                    this.openModal(cardIndex);
                }
            });
        }

        /**
         * モーダル設定
         */
        setupModal() {
            const modal = document.getElementById('perfumeProductModal');
            const closeBtn = document.getElementById('perfumeModalClose');
            
            if (!modal || !closeBtn) return;
            
            closeBtn.addEventListener('click', () => this.closeModal());

            this.setupModalButtons();
            
            // モーダル外クリックで閉じる
            modal.addEventListener('click', (e) => {
                if (e.target === modal) {
                    this.closeModal();
                }
            });
            
            // ESCキーで閉じる
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && this.modalIsOpen) {
                    this.closeModal();
                }
                // 左右キーでナビゲーション
                if (this.modalIsOpen) {
                    if (e.key === 'ArrowLeft') {
                        this.previousModalItem();
                    } else if (e.key === 'ArrowRight') {
                        this.nextModalItem();
                    }
                }
            });
            
            // モーダル内スワイプ機能を設定
            this.setupModalSwipe();
        }

        setupModalButtons() {
            // 前へボタン（SP・PC両方を取得）
            const prevButtons = document.querySelectorAll('button.perfume-modal__nav--prev');
            
            // 次へボタン（SP・PC両方を取得）
            const nextButtons = document.querySelectorAll('button.perfume-modal__nav--next');
            
            // 前へボタンのイベント設定（全ての要素に設定）
            prevButtons.forEach((button, index) => {
                if (button) {
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.previousModalItem();
                    });
                }
            });
            
            // 次へボタンのイベント設定（全ての要素に設定）
            nextButtons.forEach((button, index) => {
                if (button) {
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.nextModalItem();
                    });
                }
            });
        }

        /**
         * モーダル内スワイプ設定
         */
        setupModalSwipe() {
            const modal = document.getElementById('perfumeProductModal');
            const modalContent = modal?.querySelector('.perfume-modal__content');
            if (!modalContent) return;
            
            let startX = 0;
            let startY = 0;
            let currentX = 0;
            let currentY = 0;
            let isDragging = false;

            // タッチ開始
            modalContent.addEventListener('touchstart', (e) => {
                startX = e.touches[0].clientX;
                startY = e.touches[0].clientY;
                currentX = startX;
                currentY = startY;
                isDragging = true;
            });

            // タッチ移動
            modalContent.addEventListener('touchmove', (e) => {
                if (!isDragging) return;
                
                currentX = e.touches[0].clientX;
                currentY = e.touches[0].clientY;
                
                const deltaX = Math.abs(currentX - startX);
                const deltaY = Math.abs(currentY - startY);
                
                // 横スワイプの場合はデフォルト動作を防ぐ
                if (deltaX > deltaY && deltaX > 30) {
                    e.preventDefault();
                }
            });

            // タッチ終了
            modalContent.addEventListener('touchend', (e) => {
                if (!isDragging) return;
                
                const deltaX = currentX - startX;
                const deltaY = Math.abs(currentY - startY);
                
                // 横スワイプでナビゲーション
                if (Math.abs(deltaX) > deltaY && Math.abs(deltaX) > 50) {
                    if (deltaX > 0) {
                        this.previousModalItem();
                    } else {
                        this.nextModalItem();
                    }
                }
                
                isDragging = false;
            });
        }

        /**
         * モーダルを開く
         * @param {number} index 商品インデックス
         */
        openModal(index) {
            const product = this.products.find(p => p.index === index);
            if (!product) return;
            
            this.currentModalIndex = index;
            this.modalIsOpen = true;
            
            // モーダルを先に表示してからコンテンツを更新
            const modal = document.getElementById('perfumeProductModal');
            if (modal) {
                modal.style.display = 'flex';
                // アニメーション用のクラスを追加
                requestAnimationFrame(() => {
                    modal.classList.add('perfume-modal--show');
                    // モーダルが表示された後にコンテンツを更新
                    this.updateModalContent();
                });
            }
            
            // メインカルーセルと同期
            this.syncMainCarouselWithModal();
        }

        /**
         * モーダルを閉じる
         */
        closeModal() {
            const modal = document.getElementById('perfumeProductModal');
            if (modal) {
                modal.classList.remove('perfume-modal--show');
                // アニメーション完了後に非表示
                setTimeout(() => {
                    modal.style.display = 'none';
                }, 300);
            }
            this.modalIsOpen = false;
        }

        /**
         * 前の商品へ
         */
        previousModalItem() {
            const currentProduct = this.products.find(p => p.index === this.currentModalIndex);
            const currentProductIndex = this.products.indexOf(currentProduct);
            
            if (currentProductIndex > 0) {
                this.currentModalIndex = this.products[currentProductIndex - 1].index;
            } else {
                this.currentModalIndex = this.products[this.products.length - 1].index;
            }
            
            this.updateModalContent();
            this.syncMainCarouselWithModal();
        }

        /**
         * 次の商品へ
         */
        nextModalItem() {
            const currentProduct = this.products.find(p => p.index === this.currentModalIndex);
            const currentProductIndex = this.products.indexOf(currentProduct);
            
            if (currentProductIndex < this.products.length - 1) {
                this.currentModalIndex = this.products[currentProductIndex + 1].index;
            } else {
                this.currentModalIndex = this.products[0].index;
            }
            
            this.updateModalContent();
            this.syncMainCarouselWithModal();
        }

        /**
         * メインカルーセルとモーダルの同期（モーダル → メイン）
         */
        syncMainCarouselWithModal() {
            if (!this.swiper || !this.modalIsOpen) return;
            
            const currentProduct = this.products.find(p => p.index === this.currentModalIndex);
            const currentProductIndex = this.products.indexOf(currentProduct);
            
            if (currentProductIndex !== -1) {
                this.swiper.slideTo(currentProductIndex, 300);
            }
        }

        /**
         * モーダルとメインカルーセルの同期（メイン → モーダル）
         */
        syncModalWithMainCarousel() {
            if (!this.swiper || !this.modalIsOpen) return;
            
            const activeIndex = this.swiper.activeIndex;
            if (activeIndex < this.products.length) {
                this.currentModalIndex = this.products[activeIndex].index;
                this.updateModalContent();
            }
        }

        /**
         * モーダルコンテンツ更新
         */
        updateModalContent() {
            const product = this.products.find(p => p.index === this.currentModalIndex);
            if (!product) return;

            // 画像を動的に生成・更新
            const modalImageContainer = document.getElementById('modalImageContainer');
            if (modalImageContainer) {
                // 既存のimgタグがあれば削除
                const existingImage = modalImageContainer.querySelector('img');
                if (existingImage) {
                    existingImage.remove();
                }
                
                // 新しいimgタグを作成
                const modalImage = document.createElement('img');
                modalImage.id = 'modalImage';
                modalImage.alt = product.alt;
                
                // プリロードされた画像があれば使用、なければ通常の読み込み
                if (this.imageCache && this.imageCache.has(product.index)) {
                    const cachedImage = this.imageCache.get(product.index);
                    modalImage.src = cachedImage.src;
                } else {
                    modalImage.src = this.resolveImageUrl(product.modalImage);
                }
                
                // コンテナに追加
                modalImageContainer.appendChild(modalImage);
            }

            // バッジを更新
            const modalBadge = document.getElementById('modalBadge');
            if (modalBadge) {
                modalBadge.style.display = product.hasNewBadge ? 'block' : 'none';
                modalBadge.textContent = product.badgeText;
            }

            // タイトルのマージン調整
            const modalTitle = document.getElementById('modalTitle');
            if (modalTitle) {
                modalTitle.textContent = product.title;
                if (product.hasNewBadge) {
                    modalTitle.classList.remove('no-badge');
                } else {
                    modalTitle.classList.add('no-badge');
                }
            }

            const modalCta = document.getElementById('modalCta');
            if (modalCta) {
                // データ属性にURLを設定
                modalCta.setAttribute('data-href', product.ctaHref);
                modalCta.setAttribute('data-ga-label', product.gaLabel);
                
                // クリックイベント設定（一度だけ）
                if (!modalCta.hasAttribute('data-initialized')) {
                    modalCta.addEventListener('click', function() {
                        const href = this.getAttribute('data-href');
                        if (href) {
                            // 同じタブで開く
                            window.location.href = href;
                            
                            // 新しいタブで開く場合
                            // window.open(href, '_blank');
                        }
                    });
                    modalCta.setAttribute('data-initialized', 'true');
                }
            }

            // テキスト情報を更新
            this.updateModalTextContent('modalSubtitle', product.subtitle);
            this.updateModalTextContent('modalDescription', product.titleDesc);
            this.updateModalTextContent('modalDescriptionAdditional', product.description);
            this.updateModalTextContent('modalTopNotes', product.top);
            this.updateModalTextContent('modalMiddleNotes', product.middle);
            this.updateModalTextContent('modalLastNotes', product.last);

            // ノートセクション全体の表示/非表示
            const modalNotes = document.getElementById('modalNotes');
            if (modalNotes) {
                modalNotes.style.display = (product.top || product.middle || product.last) ? 'block' : 'none';
            }

            // CTAリンクを更新
            // const modalCta = document.getElementById('modalCta');
            // if (modalCta) {
            //     modalCta.href = product.ctaHref;
            //     modalCta.setAttribute('data-ga-label', product.gaLabel);
            //     modalCta.removeAttribute('data-cta-ga');
            // }
        }

        /**
         * モーダルテキストコンテンツ更新ヘルパー
         * @param {string} elementId 要素ID
         * @param {string} content コンテンツ
         */
        updateModalTextContent(elementId, content) {
            const element = document.getElementById(elementId);
            if (element) {
                element.innerHTML = content;
            }
        }

        /**
         * カルーセルを非表示にする
         */
        hideCarousel() {
            const container = document.querySelector('.perfume-container');
            if (container) {
                container.style.display = 'none';
            }
        }

        /**
         * カルーセルを表示する
         */
        showCarousel() {
            const container = document.querySelector('.perfume-container');
            if (container) {
                container.style.display = 'block';
            }
        }

        /**
         * モーダル画像のプリロード
         */
        preloadModalImages() {
            this.products.forEach(product => {
                if (product.modalImage) {
                    const img = new Image();
                    img.src = this.resolveImageUrl(product.modalImage);
                    // プリロードした画像をキャッシュに保存
                    if (!this.imageCache) {
                        this.imageCache = new Map();
                    }
                    this.imageCache.set(product.index, img);
                }
            });
        }

        /**
         * リサイズ処理
         */
        handleResize() {
            window.addEventListener('resize', () => {
                // デバウンス処理
                clearTimeout(this.resizeTimer);
                this.resizeTimer = setTimeout(() => {
                    this.initCarousel2Row();
                }, 100);
            });
        }
    }

        // グローバルに公開
        window.PerfumeManager = PerfumeManager;
    }

    // グローバルオブジェクトとして公開（重複チェック）
    if (typeof window.perfumeManager === 'undefined') {
        window.perfumeManager = {
            instance: null,
            
            /**
             * 前の商品へ
             */
            previousModalItem: function() {
                console.log('previousModalItem called, instance:', this.instance);
                if (this.instance) {
                    this.instance.previousModalItem();
                } else {
                    console.warn('PerfumeManager instance is not initialized');
                }
            },
            
            /**
             * 次の商品へ
             */
            nextModalItem: function() {
                console.log('nextModalItem called, instance:', this.instance);
                if (this.instance) {
                    this.instance.nextModalItem();
                } else {
                    console.warn('PerfumeManager instance is not initialized');
                }
            }
        };
    }

    // グローバル関数としても公開（HTMLのonclick属性との互換性のため）
    if (typeof window.perfumeManagerPreviousModalItem === 'undefined') {
        window.perfumeManagerPreviousModalItem = function() {
            if (window.perfumeManager && window.perfumeManager.instance) {
                window.perfumeManager.instance.previousModalItem();
            } else {
                console.warn('PerfumeManager instance is not initialized');
            }
        };
    }

    if (typeof window.perfumeManagerNextModalItem === 'undefined') {
        window.perfumeManagerNextModalItem = function() {
            if (window.perfumeManager && window.perfumeManager.instance) {
                window.perfumeManager.instance.nextModalItem();
            } else {
                console.warn('PerfumeManager instance is not initialized');
            }
        };
    }

    // 初期化関数
    function initializePerfumeManager() {
        // 既に初期化済みの場合はスキップ
        if (window.perfumeManager && window.perfumeManager.instance) {
            console.log('PerfumeManager already initialized');
            return;
        }
        
        // PerfumeManagerを初期化
        if (window.perfumeManager && window.PerfumeManager) {
            console.log('Initializing PerfumeManager...');
            window.perfumeManager.instance = new window.PerfumeManager();
            console.log('PerfumeManager initialized successfully');
        } else {
            console.error('PerfumeManager class or perfumeManager object not available');
        }
    }

    // DOMContentLoaded時の初期化
    document.addEventListener('DOMContentLoaded', initializePerfumeManager);
    
    // 即座に実行も試行（すでにDOMが読み込まれている場合用）
    if (document.readyState === 'loading') {
        // まだ読み込み中
    } else {
        // すでに読み込み完了している
        initializePerfumeManager();
    }

})();